var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-add-button"},[_c('div',{staticClass:"flex items-center",on:{"click":function($event){return _vm.click()}}},[_c('feather-icon',{staticClass:"mr-1",attrs:{"icon":_vm.icon,"svg-classes":"h-6 w-6"}}),_c('span',[_vm._v(_vm._s(_vm.title))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }